// extracted by mini-css-extract-plugin
module.exports =  {"warning_withBackground":"InlineMessageWarning-module__warning_withBackground___MJ_iV","warning__icon":"InlineMessageWarning-module__warning__icon___eZZxn"};